import styled from "styled-components";

export const GetItemObservationsModalStyled = styled.div`

`